import { render, staticRenderFns } from "./BookingDetailMobile.vue?vue&type=template&id=32ec66fc&scoped=true&"
import script from "./BookingDetailMobile.vue?vue&type=script&lang=js&"
export * from "./BookingDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetailMobile.vue?vue&type=style&index=0&id=32ec66fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec66fc",
  null
  
)

export default component.exports